<template>
    <span 
    class="inline-flex items-center justify-center rounded-full select-none"
    :class="sizeClass + ' ' + LoadColor()">
        <span 
        v-if="!Image && !UserImage"
        class="font-bold text-white"
        :class="textSize">
            {{ ComputeText }}
        </span>
        <img
        v-else
        :src="UserImage ? UserImage : Image"
        :alt="ComputeText"
        class="w-full h-full object-cover rounded-full"
        />
    </span>
</template>

<script>
import ColorGenerator from "@/utils/ColorGenerator.js";
export default {
    name: "Avatar",
    props: {
        size: {
            type: [String, Number],
            default: "6"
        },
        text: {
            type: String,
            default: "TW"
        },
        user: {
            type: Object,
            default: null
        },
        textSize: {
            type: String,
            default: "text-xs"
        },
        Image: {
            type: String,
            default: null
        }
    },
    computed: {
        sizeClass() {
            return `size-${this.size}`;
        },
        ComputeText() {
            if (this.user) {
                return this.user.firstname.charAt(0).toUpperCase() + this.user.lastname.charAt(0).toUpperCase();
            }
            return this.text;
        },
        UserImage() {
            if (this.user && this.user.Image) {
                return this.user.Image;
            }
            return null;
        }
    },
    methods: {
        LoadColor() {
            if (this.user) {
                return ColorGenerator(this.user.firstname + this.user.lastname);
            }
            return "bg-gray-400";
        }
    }
};
</script>